<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      login: true
    }
  }
}
</script>

<style>
  body {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
  }
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    margin-top: 0;
    height: 100%;
    word-break: break-word;
  }
  .img-ref {
    display: block;
    padding: 8px 0;
    text-align: center;
    font-style: italic;
    color: rgb(155, 155, 155);
  }
  .text-left {
    text-align: left !important;
  }
  .text-right {
    text-align: right !important;
  }
</style>



// WEBPACK FOOTER //
// App.vue?3d3bbdba